import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Colton Wiscombe
 * id 30D8C8F6-3BDE-40B8-A015-6E607C370360
 * name star-settings
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/star-settings.svg
 * tags
 * - Settings 
 */
export const StarSettingsIcon = createSvgIcon(<><path d="M7 22H9V24H7V22M11 24H13V22H11V24M15 24H17V22H15V24M22 9.24L14.81 8.62L12 2L9.19 8.62L2 9.24L7.45 13.97L5.82 21L12 17.27L18.18 21L16.54 13.97L22 9.24Z" /></>, 'StarSettingsIcon');
export default StarSettingsIcon